import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import accounting from 'accounting'
import 'react-datepicker/dist/react-datepicker.css'

export default class PaymentForm extends Component {
  state = {
    due_date: null,
    paid_at: null,
    amount_owed: null,
    amount_paid: null,
    description: '',
  }

  handleCurrencyChange(event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleTextChange(event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  createAmountOwed() {
    const { resident_id } = this.props
    const { due_date, amount_owed, description } = this.state
    return this.props.createPayment({
      resident_id: resident_id,
      due_date: due_date.format('YYYY-MM-DDTHH:mm:ss'),
      amount_owed: accounting.unformat(amount_owed),
      description
    })
  }

  createAmountPaid() {
    const { resident_id } = this.props
    const { paid_at, amount_paid } = this.state
    return this.props.createPayment({
      resident_id: resident_id,
      paid_at: paid_at.format('YYYY-MM-DDTHH:mm:ss'),
      amount_paid: accounting.unformat(amount_paid),
      description: 'Payment'
    })
  }

  handleCreatePayment() {
    const { due_date, paid_at, amount_owed, amount_paid, description } = this.state
    const { resident_id } = this.props

    if(amount_owed && amount_paid) {
      this.createAmountOwed().then(() => {
        this.createAmountPaid().then(() => {
          this.resetState()
        })
      })
    } else if(amount_owed) {
      this.createAmountOwed().then(() => {
        this.resetState()
      })
    } else if(amount_paid) {
      this.createAmountPaid().then(() => {
        this.resetState()
      })
    }
  }

  resetState() {
    this.setState({
      due_date: null,
      paid_at: null,
      amount_owed: null,
      amount_paid: null,
      description: '',
    })
  }

  isValid() {
    const { due_date, amount_owed, amount_paid, paid_at } = this.state
    return (
      due_date && amount_owed && !paid_at && !amount_paid ||
      !due_date && !amount_owed && paid_at && amount_paid ||
      due_date && amount_owed && paid_at && amount_paid
    )
  }

  render() {
    const { due_date, amount_owed, amount_paid, description, paid_at } = this.state

    return (
      <div className="form-group row">
        <div className="col-sm-4">
          <label>Due date</label>
          <DatePicker
            className="form-control form-control-sm"
            selected={due_date}
            onChange={(due_date) => this.setState({ due_date })} />
        </div>
        <div className="col-sm-4">
          <label>Amount owed</label>
          <MaskedInput
            mask={createNumberMask({ allowDecimal: true })}
            name="amount_owed"
            className="form-control form-control-sm"
            value={amount_owed}
            onChange={(event) => this.handleCurrencyChange(event)} />
        </div>
        <div className="col-sm-4">
          <label>Description</label>
          <input
            className="form-control form-control-sm"
            name="description"
            value={description}
            onChange={(event) => this.handleTextChange(event)} />
        </div>
        <div className="col-sm-4">
          <label>Date paid</label>
          <DatePicker
            className="form-control form-control-sm"
            selected={paid_at}
            onChange={(paid_at) => this.setState({ paid_at })} />
        </div>
        <div className="col-sm-4">
          <label>Amount paid</label>
          <MaskedInput
            mask={createNumberMask({ allowDecimal: true })}
            name="amount_paid"
            className="form-control form-control-sm"
            value={amount_paid}
            onChange={(event) => this.handleCurrencyChange(event)} />
        </div>
        <div className="col-sm-2">
          <button
            type="button"
            className="btn btn-primary mt-4"
            onClick={() => this.handleCreatePayment()}
            disabled={!this.isValid()}>
            Add
          </button>
        </div>
      </div>
    )
  }
}
